import { render, staticRenderFns } from "./DialogRequestResetPasswordExpired.vue?vue&type=template&id=c20a9a28&scoped=true&"
import script from "./DialogRequestResetPasswordExpired.vue?vue&type=script&lang=ts&"
export * from "./DialogRequestResetPasswordExpired.vue?vue&type=script&lang=ts&"
import style0 from "./DialogRequestResetPasswordExpired.vue?vue&type=style&index=0&id=c20a9a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20a9a28",
  null
  
)

export default component.exports